import React from "react";

// Dependecies
import { Box, CssBaseline } from "@mui/material";
import { StyledEngineProvider } from "@mui/material/styles";
import { ThemeProvider } from "@mui/material/styles";

// Router
import { BrowserRouter as Router } from "react-router-dom";

// Styles
import { theme } from "./context/theme";

// import Navigtation from "Navigation";
import Frame from "Frame";

// Redux
import { Provider } from 'react-redux';
import { store } from './store/store';

// Forms context
import { FormProvider } from './context/FormContext';
import { ProjectProvider } from "context/ProjectContext";

const App = () => {

  return (
    <StyledEngineProvider injectFirst>
      <Provider store={store}>
        <ThemeProvider theme={theme}>
          <ProjectProvider>
            <FormProvider>
              <CssBaseline />
              <Router basename="/">
                <Frame />
              </Router>
            </FormProvider>
          </ProjectProvider>
        </ThemeProvider>
      </Provider>
    </StyledEngineProvider>
  );
};

export default App;
